module.exports = __webpack_public_path__ + "img/planting_01@2x.d8a3716.webp";